module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpDownloads"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('p', [_vm._v("Browse and download resources to support your patients")]), _vm._v(" "), _vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(cat, index) {
      return _c('mu-flexbox-item', {
        key: 'cat-' + index,
        staticClass: "cat",
        style: ('background-image: url(' + cat.image + ');')
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-start",
          "align": "center"
        }
      }, [_c('mu-card', {
        nativeOn: {
          "click": function($event) {
            return _vm.goTo(cat.slug)
          }
        }
      }, [_c('mu-card-text', [_c('div', {
        staticClass: "cat-desc"
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [_vm._o(_c('span', [_vm._v(_vm._s(cat.name))]), 0, 'cat-' + index)]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(cat.desc))])]), _vm._v(" "), _c('span', {
        staticClass: "view-all"
      }, [_vm._v("View All")])])])])], 1)], 1)], 1)
    }), 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4f5bc8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Downloads/HCPDownloads.vue
// module id = 3218
// module chunks = 1